import questionnaireRoutes from "./questionnaire-routes";

export default (router: any) => {
  questionnaireRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
